// SPEEDOGO - Carrossel genérico (hero e cards de produto)
// v2: sem rolagem automática. Em vez de bolinhas, mostra uma miniatura de
// cada foto do carrossel abaixo da imagem principal (clique pra trocar).
// Uso: <div data-carousel>
//        <div data-track>...slides (cada um com 1 <img>)...</div>
//        <button data-prev>‹</button>
//        <button data-next>›</button>
//      </div>
//      <div data-dots></div>  (pode ficar fora do [data-carousel], como
//                              irmão dele ou em qualquer lugar do mesmo pai)
(function () {
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]:not([data-carousel-ready])').forEach(function (car) {
      car.setAttribute('data-carousel-ready', '1');
      var track = car.querySelector('[data-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);

      var thumbsWrap = car.querySelector('[data-dots]');
      if (!thumbsWrap && car.parentNode) thumbsWrap = car.parentNode.querySelector('[data-dots]');

      if (slides.length <= 1) {
        car.querySelectorAll('[data-prev], [data-next]').forEach(function (a) { a.style.display = 'none'; });
        if (thumbsWrap) thumbsWrap.style.display = 'none';
        return;
      }

      var index = 0;
      var thumbEls = [];

      if (thumbsWrap) {
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('img');
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.setAttribute('aria-label', 'Ver foto ' + (i + 1));
          if (img) {
            var thumbImg = document.createElement('img');
            thumbImg.src = img.getAttribute('src');
            thumbImg.alt = img.getAttribute('alt') || '';
            thumbImg.loading = 'lazy';
            thumb.appendChild(thumbImg);
          }
          thumb.addEventListener('click', function () { goTo(i); });
          thumbsWrap.appendChild(thumb);
          thumbEls.push(thumb);
        });
      }

      function update() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        thumbEls.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        update();
      }

      var prevBtn = car.querySelector('[data-prev]');
      var nextBtn = car.querySelector('[data-next]');
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(index + 1); });

      var startX = null;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? goTo(index + 1) : goTo(index - 1); }
        startX = null;
      }, { passive: true });

      update();
    });
  }

  window.initCarousels = initCarousels;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(document); });
  } else {
    initCarousels(document);
  }
})();
